import { api } from '../lib/axios';

interface Color {
  id: number;
  nome: string;
}

interface DescriptionItems {
  id: number;
  nome: string;
}

interface Fuel {
  id: number;
  nome: string;
}

interface Optional {
  id: number;
  nome: string;
  categoria: string;
}

interface GetPriceProps {
  versionId: number;
  modelYear: number;
  km: number;
}

interface PriceSuggestions {
  iCarros: number;
  fipe: number;
}

interface GetVehicleVersions {
  modelId: number;
  modelYear: number;
}

interface VehicleVersion {
  id: number;
  nome: string;
  marceId: number;
  marcaNome: string;
  modeloId: number;
  modeloNome: string;
  anoInicial: number;
  anoFinal: number;
  portas?: number;
}

interface VerificationChassiProps {
  veihiclePlate: string;
  chassi: string;
  idAnuncio: number;
}

interface VerificationChassiReturnProps {
  mensagem: string,
  status: boolean
}

export function getColors(): Promise<Color[]> {
  return api.get('cores');
}

export function getDescriptionItems(): Promise<DescriptionItems[]> {
  return api.get('item-descricao');
}

export function getOptionals(): Promise<Optional[]> {
  return api.get('opcional');
}

export function getFuels(): Promise<Fuel[]> {
  return api.get('combustivel');
}

export function getDoors(): Promise<number[]> {
  return api.get('porta');
}

export function getPriceSuggestions({
  versionId,
  modelYear,
  km
}: GetPriceProps): Promise<PriceSuggestions> {
  return api.get('preco', {
    params: {
      versaoId: versionId,
      anoModelo: modelYear,
      km
    }
  });
}

export function getVehicleVersions({
  modelId,
  modelYear
}: GetVehicleVersions): Promise<VehicleVersion[]> {
  return api.get('dados-gerais/versao', {
    params: {
      modeloId: modelId,
      anoModelo: modelYear
    }
  });
}

export function verificationChassi({ idAnuncio, chassi, veihiclePlate }: VerificationChassiProps): Promise<VerificationChassiReturnProps> {
  return api.get(`auditoria/veiculo/chassi/${chassi}`, {
    params: {
      anuncioId: idAnuncio,
      placa: veihiclePlate
    }
  });
}
